module.exports = __webpack_public_path__ + "assets/img/main-logo-handan.9ac82ece.png";